import React from "react";
import "./WelcomeModal.scss";
import { X } from "lucide-react";

const WelcomeModal = ({
  title,
  text,
  leftBtnText,
  rightBtnText,
  isOpened,
  close,
  handleStayPage,
  handleEducation
}) => {
  return isOpened ? (
    <div className="CancelModal-cont">
      <div className="CancelModal-cont__content WelcomeModal-cont__content" onClick={(e) => (e.stopPropagation())}>
        <button className="WelcomeModal-cont__content__close" onClick={close}>
          <X strokeWidth={1} size={36} />
        </button>
        <div className="WelcomeModal-cont__content__textCont">
          <p className="WelcomeModal-cont__content__textCont__title">{title}</p>
          <p className="WelcomeModal-cont__content__textCont__text">{text}</p>
        </div>
        <div className="WelcomeModal-cont__content__btnContainer">
          <button className="WelcomeModal-cont__content__btnContainer__btn1" onClick={handleStayPage}>
            {leftBtnText}
          </button>
          <button className="WelcomeModal-cont__content__btnContainer__btn2" onClick={handleEducation}>
            {rightBtnText}
          </button>
        </div>
      </div>
    </div>
  ) : null;
};

export default WelcomeModal;